import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { useLanguage } from "@/context/LanguageContext";

export default function FeaturedProducts() {
    const { t } = useLanguage();
    const [products, setProducts] = useState([]);

    useEffect(() => {
        fetchProducts()
            .then((data) => setProducts(data.slice(0, 3)))
            .catch(() => setProducts([]));
    }, []);

    if (products.length === 0) return null;

    return (
        <section className="py-24 md:py-32 px-5 md:px-10" data-testid="featured-products-section">
            <div className="mb-12 flex items-end justify-between">
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tight"
                >
                    {t("featured.title")}
                </motion.h2>
                <Link
                    to="/shop"
                    data-testid="featured-view-all"
                    className="group hidden md:flex items-center gap-2 text-xs tracking-[0.25em] uppercase font-semibold"
                >
                    {t("featured.viewAll")}
                    <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                {products.map((product, i) => (
                    <ProductCard key={product.id} product={product} index={i} />
                ))}
            </div>

            <div className="mt-10 md:hidden">
                <Link
                    to="/shop"
                    className="flex items-center justify-center gap-2 border border-black py-4 text-xs tracking-[0.25em] uppercase font-semibold"
                >
                    {t("featured.viewAll")} <ArrowRight size={14} />
                </Link>
            </div>
        </section>
    );
}
